import fixed_menuitems from "@/router/fixed_menuitems";

export default {
    set_menudata: (state, userdata) => state.menuitems = [...fixed_menuitems,...userdata],
}